import { Box } from '@mui/material';
import DropIndicator from '../../components/DropIndicator/DropIndicator';
import { useIsColumnLoading } from '../ColumnLoadingContext';
import { useDropTarget } from '../hooks/useDropTarget';

import type { PlanningEntityIdentifier, PlanningEntityType } from 'generated';

interface DropZoneV2Props {
  id: string;
  scheduleStart: string;
  start: string;
  planningEntityType: PlanningEntityType;
  planningEntityId: string;
  planningEntityIdentifier: PlanningEntityIdentifier;
}

function DropzonePragmatic({
  id,
  scheduleStart,
  start,
  planningEntityType,
  planningEntityId,
  planningEntityIdentifier
}: DropZoneV2Props) {
  'use memo';
  const isColumnLoading = useIsColumnLoading();

  const ref = useDropTarget({
    slotKey: id,
    scheduleStart,
    start,
    planningEntityType,
    planningEntityId,
    planningEntityIdentifier,
    canDrop: !isColumnLoading
  });

  return (
    <Box
      component="li"
      ref={ref}
      display="flex"
      flexShrink={0}
      className="dropzone"
      justifyContent="center"
      alignItems="center"
      sx={{
        boxSizing: 'border-box',
        minHeight: '8px',
        width: '100%',
        color: '#6b6b6b',
        fontSize: '10px',
        height: '30px',
        margin: '-10px 0',
        position: 'relative',
        zIndex: 1,
        '&:first-of-type': {
          marginTop: '-20px'
        },
        '& .dropzone__indicator': { display: 'none' },
        '&[data-drag-over] .dropzone__indicator': { display: 'block' }
      }}
    >
      <DropIndicator className="dropzone__indicator" />
    </Box>
  );
}

export default DropzonePragmatic;
